import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa6";
import Stats from "./stats";
import BasicInfo from "./basicInfo";
import RegisteredList from "./registeredList";
import Button from "../../../components/buttons/button";
import { useState } from "react";
import ManualRegistration from "../manualRegistration";
import SendNotification from "../sendNotification";
import Popup from "../../../components/popups/popup";
import { useNavigate } from "react-router-dom";

const OneActivity = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openRegistration, setOpenRegistration] = useState(false);
  const [openSend, setOpenSend] = useState(false);
  return (
    <main>
      <div className="flex items-center gap-4 my-5">
        <h1
          onClick={() => navigate("/activities")}
          className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
        >
          {t("activities")}
        </h1>
        <FaChevronLeft className="ltr:rotate-180" />
        <p className="font-bold capitalize">{t("activityDetails")}</p>
      </div>
      <article className="px-6 py-8 border border-white rounded-xl">
        <h1 className="my-4 text-lg font-bold capitalize md:text-2xl">
          {t("showActivityDetails")}
        </h1>
        <Stats t={t} />
        <BasicInfo t={t} />
        <RegisteredList t={t} />
        <div className="flex items-center gap-2">
          <Button
            onClick={() => setOpenRegistration(true)}
            className={"bg-primary w-full flex justify-center text-black py-3"}
          >
            {t("manualMemberRegistration")}
          </Button>
          <Button
            onClick={() => setOpenSend(true)}
            className={"border border-white text-white w-full flex justify-center py-3"}
          >
            {t("sendNotification")}
          </Button>
        </div>
      </article>
      <Popup
        open={openRegistration}
        setOpen={setOpenRegistration}
        header={t("manualMemberRegistration")}
      >
        <ManualRegistration t={t} />
      </Popup>
      <Popup open={openSend} setOpen={setOpenSend} header={t("sendNotification2")}>
        <SendNotification t={t} setOpen={setOpenSend} />
      </Popup>
    </main>
  );
};

export default OneActivity;
